// PdfDocument.js
import React, {useContext} from 'react';
import {
    Font,
    Page,
    Document,
    BlobProvider,
} from '@react-pdf/renderer';
import {ConfigContext} from "../context/ConfigContext";
import {TextSectionsListContext} from "../context/TextSectionsListContext";
import Html from "react-pdf-html";
import ReactDOMServer from 'react-dom/server';
import PdfForStonemasons from './PdfForStonemasons';
import PdfForCutting from './PdfForCutting';
import {WorkingSizeContext} from "../context/WorkingSizeContext";
import {convertCmToPx, convertCmToPxWithScaling} from "../services/helpers";
import FontsMapper from "../services/FontsMapper";

const fontsMapper = new FontsMapper();

const PdfForStonemasones = ({list, configData, a4Config , workingSize}) => {
    //console.log('list in pdf', list);
    const data = configData;
    const pdfItemsToRender = list;

    if (!configData || !pdfItemsToRender) {
        return <div>No configuration data available</div>;
    }

    const htmlElements = [];
    const defaultStyles = {
        height: a4Config.widthPx * 0.75,
        width: a4Config.heightPx * 0.75,
        overflow: 'hidden',
        border: '1px solid #000',
        boxSizing: 'border-box',
        marginBottom: '-1px',
        marginleft: '-1px',
        padding : '0'
    }
    //Generujemy strony w poziomie i pionie
    //Ustalamy liczbę stron w poziomie i pionie
    const verticalPages = Math.ceil(workingSize.widthCm / 29.7);
    const horizontalPages = Math.ceil(workingSize.heightCm / 21);
    //Pętla po stronach w poziomie
    for (let j = 0; j < horizontalPages; j++) {
        //Pętla po stronach w pionie
        for (let i = 0; i < verticalPages; i++) {
            const styles = {transform: `translate(${i * (-1 * (a4Config.heightPx * 0.75))}px , ${j * (-1 * (a4Config.widthPx * 0.75))}px)`,};
            Object.assign(styles, defaultStyles);
            const html = ReactDOMServer.renderToStaticMarkup(
                <PdfForStonemasons
                    pdfItemsToRender={pdfItemsToRender}
                    data={data}
                    margin={configData.additionalWorkingSizeMargin}
                    scale={workingSize.scale}
                    letterSpacing={ data.selectedLetterSpacing }
                    workingSize={workingSize}
                    showGrid={configData.showGrid}
                    mainContainerHeight={a4Config.widthPx * 0.75}
                />
            );
            //console.log('html for page', html);
            htmlElements.push(
                <Page
                    wrap={false}
                    size={"A4"}
                    orientation="landscape"
                    >
                    <Html
                        key={i}
                        style={styles}
                    >
                        {html}
                    </Html>
                </Page>
            );
        }
    }
    return (
        <Document language="pl">
            {htmlElements}
        </Document>
    );
};

const PdfDocumentForCutting = ({list, configData, a4Config , workingSize}) => {
    const data = configData;
    const pdfItemsToRender = list;
    const letterSpacing = convertCmToPxWithScaling(data.selectedLetterSpacing, workingSize.scale) * 0.75;

    if (!configData || !pdfItemsToRender) {
        return <div>No configuration data available</div>;
    }

    const defaultStyles = {
        height: a4Config.widthPx * 0.75,
        width: a4Config.heightPx * 0.75,
        overflow: 'hidden',
        border: '1px solid #000',
        boxSizing: 'border-box',
        marginBottom: '-1px',
        marginleft: '-1px',
        padding : '0'
    }

    const html = ReactDOMServer.renderToStaticMarkup(
        <PdfForCutting
            pdfItemsToRender={pdfItemsToRender}
            data={data}
            scale={workingSize.scale}
            letterSpacing={ data.selectedLetterSpacing }
        />
    );

    return (
        <Document language="pl">
            <Page
                size={"A4"}
                orientation="landscape"
            >
                <Html
                    style={defaultStyles}
                >
                    {html}
                </Html>
            </Page>
        </Document>
    );
};

const PdfRenderer = () => {
    const configData = useContext(ConfigContext);
    const list = useContext(TextSectionsListContext);
    const workingSizeContext = useContext(WorkingSizeContext);

    const A4Config = {
        widthPx: convertCmToPx(21),
        heightPx: convertCmToPx(29.7),
        pages: 1
    }

    const fontFamilyRegister = () => {
        const data = configData;
        data.selectedFontObject.fonts_conf.map((font) => {
            if (font.font_size) {
                let selectedFont = fontsMapper.fonts[data.selectedFontObject.woocommerce_product_id].clr;
                //console.log(selectedFont)
                let fontFamilly = selectedFont ? selectedFont[font.font_size.slug] : null;
                if (fontFamilly) {
                    Font.register({
                        family: fontFamilly.name,
                        fonts: [
                            {src: require(`../${fontFamilly.path}`)}
                        ]
                    });
                }
            }
        });
    }

    const handleOpenPdf = (url) => {
        if (url) {
            window.open(url, '_blank');
        }
    };

    fontFamilyRegister();

    return (
        <div className="row mb-5">
            <div className="col-12 col-md-6">
                <div className="heading heading--text-section" aria-labelledby="podglad-tresc">
                    <div className="heading__line"></div>
                    <div className="heading__title" id="podglad-tresc">
                        Podgląd wydruku
                    </div>
                    <div className="heading__description heading__description--full-width">
                        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                            tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                            nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
                            eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore
                            eu</p>
                    </div>
                </div>
                <BlobProvider document={
                    <PdfForStonemasones
                        configData={configData}
                        list={list}
                        size={"A4"}
                        a4Config={A4Config}
                        workingSize={workingSizeContext}
                    />}>
                    {({blob, url, loading, error}) => (
                        <button className="btn btn--secondary" onClick={() => handleOpenPdf(url)}
                                aria-label="Zobacz podgląd PDF">
                            Zobacz podgląd
                        </button>
                    )}
                </BlobProvider>
            </div>
            <div className="col-12 col-md-6">
                <div className="heading heading--text-section" aria-labelledby="podglad-wydruk">
                    <div className="heading__line"></div>
                    <div className="heading__title" id="podglad-wydruk">
                        Podgląd wydruku (do wycięcia)
                    </div>
                    <div className="heading__description heading__description--full-width">
                        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod
                            tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis
                            nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.
                            eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore
                            eu</p>

                    </div>
                </div>
                <BlobProvider document={
                    <PdfDocumentForCutting
                        configData={configData}
                        list={list}
                        size={"A4"}
                        a4Config={A4Config}
                        workingSize={workingSizeContext}
                    />}>
                    {({blob, url, loading, error}) => (
                        <button className="btn btn--secondary" onClick={() => handleOpenPdf(url)}
                                aria-label="Zobacz podgląd wydruku PDF">
                            Zobacz podgląd
                        </button>
                    )}
                </BlobProvider>
            </div>
        </div>
    );
};

export default PdfRenderer;
